import dayjs from 'dayjs';

export function getDateFromNow(epoch: number): string {
  const date = dayjs(epoch);

  return date.fromNow();
}
